export default __webpack_public_path__ + "static/media/1837.3d02594a.png";